export default function breadcrumb() {
    return {
        restrict: "E",
        scope: {},
        replace: false,
        template: require("./template.html"),

        controller: function($scope, houseService) {
            $scope.searchFilter = houseService.searchFilter;

            $scope.goBackToLanes = function() {
                // This function has not been testet
            };
        }
    };
}
